
/**
 * Función que abre la página de pago en una nueva ventana
 * @returns {Object} openPaymentPage
 * @prop {Function} openPaymentPage - Función que abre la página de pago en una nueva ventana
 * @prop {Function} openPaymentPage.data - Datos de la página de pago
 */
export const usePaymentHandler = () => {
	const openPaymentPage = ({ data }) => {
		const paymentLink = data?.paymentLink;
		if (paymentLink) {
			window.open(paymentLink, "_blank", "noopener,noreferrer");
		}
	};
	return {
		openPaymentPage,
	};
};
